import { Button, RadioGroup } from "@material-ui/core";
import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { RootState } from "../store/reduxStore";
import { launchExperience, setSelectedStyle, setSelectionStep } from "../store/selections/selectionsActions";
import { OptionSelection, SelectionStep } from "../store/selections/selectionsTypes";
import Hashids from "hashids";
import Tile from "./Tile";

const StylesDiv = styled.div`
	margin: 30px;
	width: 100%;
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-x: hidden;
	text-align: center;
`;

const Subtitle = styled.div`
	padding: 30px;
	font-size: 24px;
	line-height: 28px;
	text-align: left;
`;

const NextButton = styled(Button)`
	font-size: 24px;
	background: #012169;
	border-radius: 3px;
	padding: 15px 110px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const BackButton = styled(Button)`
	font-size: 24px;
	border-radius: 3px;
	padding: 15px 110px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const Tiles = styled(RadioGroup)`
	flex: 1;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
`;

const Blank = styled.div`
	flex: 1;
`;

interface StyleOption extends OptionSelection {
	name: string;
	code: string;
}

function Styles(): ReactElement {
	const dispatch = useDispatch();
	// const optionsValue = useSelector<RootState, number>((state) => state.selections.optionsValue);
	const styleIndex = useSelector<RootState, number>((state) => state.selections.styleIndex);
	// const layoutIndex = useSelector<RootState, number>((state) => state.selections.layoutIndex);

	const styles: StyleOption[] = [
		{ name: "Light", code: "" },
		{ name: "Dark", code: "wKmOYym", thumb: "dark.png" },
		{ name: "Style C", code: "" },
		{ name: "Style D", code: "" },
	];

	const onNext = () => {
		// const style = styles[styleIndex];
		// const codeVersion = 1; /// Must stay in sync with unreal's code version (BP_ChangeableController)

		// Code format: vlocccccccc...
		// v = version, l = layout, o = option bitfield, c = code, all digits
		const code: number[] = []; // `${codeVersion}${layoutIndex}${optionsValue}${style.code}`;

		const hashids = new Hashids();
		const hash = hashids.encode(code);

		console.log("Code generation disabled.", { code, hash });

		dispatch(launchExperience());
		//dispatch(setSelectionStep(SelectionStep.Done));
	};

	const onBack = () => {
		dispatch(setSelectionStep(SelectionStep.Layout));
	};

	const handleChange = (val: number) => {
		dispatch(setSelectedStyle(val));
	};

	return (
		<StylesDiv>
			<Subtitle>Select your kitchen design style:</Subtitle>
			<Tiles value={styleIndex} onChange={(ev) => handleChange(+ev.currentTarget.value)}>
				{styles.map((style, i) => {
					return (
						<Tile
							key={i}
							index={i}
							type={"radio"}
							onClick={() => handleChange(i)}
							label={style.name}
							thumbUrl={style.thumb}
						/>
					);
				})}
			</Tiles>
			<Blank />
			<NextButton variant="contained" color="primary" onClick={onNext}>
				Next
			</NextButton>
			<BackButton variant="outlined" color="primary" onClick={onBack}>
				Back
			</BackButton>
		</StylesDiv>
	);
}

export default Styles;
